import * as Yup from 'yup';
import { Node } from 'slate';

export const isEditorTextEmpty = (value: any): boolean => {
  if (value === null || value === undefined) {
    return true;
  }

  if (typeof value === 'string') {
    return value.trim() === '';
  }

  if (!Array.isArray(value)) {
    return true;
  }

  try {
    const str = Node.string(
      value as unknown as Parameters<typeof Node.string>[0],
    ).trim();
    return str === '';
  } catch {
    return true;
  }
};

export const validateEditorTextValue = (required: boolean, message: string) =>
  Yup.mixed().test('editor-text', message, (value: any) => {
    if (!required) {
      return true;
    }
    return !isEditorTextEmpty(value);
  }) as Yup.AnySchema;

export const validateEditorValue = (required: boolean, message: string) =>
  validateEditorTextValue(required, message);
